import React, { useState, useEffect } from 'react';
import { FaSwimmingPool, FaBook, FaUsers, FaInfoCircle, FaQuestionCircle, FaStar } from 'react-icons/fa';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Link } from 'react-router-dom';
import './CardStyles.css'; // 👈 Import the custom CSS
import Aos from 'aos';
import './aos.css';

function GridExample() {
  const cardData = [
    {
      title: "Special Facilities",
      text: "* Swimming Pool & Gym Full size football pitch Cafeteria & canteen Pick & Drop Services After School Activities",
      icon: <FaSwimmingPool size={50} color="#007bff" />,
      link: "/SpecialFacilities",
      bgColor: "#bb8fce", // dark gray
    },
    {
      title: "School Libraries",
      text: "The ACE libraries have fully automated system. All transactions are handled electronically",
      icon: <FaBook size={50} color="#28a745" />,
      link: "/libraries",
      bgColor: "#aed6f1", // dark gray
    },
    {
      title: "Club Activities",
      text: "Participating in extra curricular activities allows for the holistic development of the students and provides a number of health benefits.",
      icon: <FaUsers size={50} color="#17a2b8" />,
      link: "/clubs",
      bgColor: "#FFA07A", // dark gray
    },
    {
      title: "General Information",
      text: "Click here to get to general information regarding the Academy",
      icon: <FaInfoCircle size={50} color="#ffc107" />,
      link: "/GeneralInformation",
      bgColor: "#fef5e7", // dark gray
    },
    {
      title: "FAQs",
      text: "In case you run into any questions, check out FAQ information.",
      icon: <FaQuestionCircle size={50} color="#6f42c1" />,
      link: "/FAQ",
      bgColor: "#6495ED", // dark gray
    },
    {
      title: "What sets us apart",
      text: "Why we are the best?",
      icon: <FaStar size={50} color="#dc3545" />,
      link: "/WhyUs",
      bgColor: "#CCCCFF", // dark gray
    },
  ];

useEffect(() => {
    Aos.init({});
  }, [])

  return (
    <>
      <div
        style={{
          height: '5px',
          background: 'linear-gradient(to right, #007bff, #28a745)',
          borderRadius: '5px',
          margin: '40px 0',
        }}
      ></div>

      <Row xs={1} md={3} className="g-4 p-3 align-items-stretch">
        {cardData.map((item, idx) => (
          <Col key={idx}>
      
       <div data-aos="zoom-in" data-aos-duration="1500">
            <Card className="equal-height-card text-center"
             style={{ backgroundColor: item.bgColor }}
            >
              <Link to={item.link}>
                <div style={{ marginBottom: '15px' }}>{item.icon}</div>
              </Link>
              <Card.Body>
                <Card.Title>{item.title}</Card.Title>
                <Card.Text>{item.text}</Card.Text>
              </Card.Body>
            </Card>
         </div>

          </Col>
        ))}
      </Row>
    </>
  );
}

export default GridExample;
